function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { TSS_DARK_BLUE, TSS_GREEN, stylePropType } from 'tss-core-lib-common';
import withHandlers from 'recompose/withHandlers';
import Icon from 'react-svg-ikon';
import { IMG_ICON_CHECKMARK } from '../img';

var styles = void 0;

var enhance = withHandlers({
  onChange: function onChange(props) {
    return function (event) {
      return props.onChange && !props.disabled && props.onChange(props.value, event.target.checked, event);
    };
  },
  onClick: function onClick(props) {
    return function (event) {
      return props.onChange && !props.disabled && props.onChange(props.value, !props.checked, event);
    };
  }
});

var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      value = _ref.value,
      style = _ref.style,
      checkedStyle = _ref.checkedStyle,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['checked', 'value', 'style', 'checkedStyle', 'disabled', 'onChange', 'onClick']);

  return React.createElement(
    'div',
    { className: 'input-checkbox ' + css(styles.container, style) },
    React.createElement(
      'span',
      { className: css(styles.square, checked && styles.squareChecked, checked && checkedStyle, disabled && styles.disabled), role: 'button', tabIndex: 0, onClick: onClick },
      checked ? React.createElement(Icon, { src: IMG_ICON_CHECKMARK, stroke: 'white' }) : null
    ),
    React.createElement('input', Object.assign({ disabled: disabled, type: 'checkbox', value: value, checked: checked, onChange: onChange, className: css(styles.checkbox) }, props))
  );
};

Checkbox.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.bool]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  checkedStyle: stylePropType,
  style: stylePropType,
  onChange: PropTypes.func,
  onClick: PropTypes.func.isRequired
};

Checkbox.defaultProps = {
  value: '',
  checked: false,
  disabled: false,
  style: null,
  checkedStyle: null,
  onChange: null
};

styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    cursor: 'pointer'
  },

  square: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: TSS_DARK_BLUE(0.15),
    border: 0,
    borderRadius: 4,
    width: '2.2rem',
    height: '2.2rem'
  },

  squareChecked: {
    backgroundColor: TSS_GREEN()
  },

  checkbox: {
    position: 'absolute',
    width: 0,
    height: 0,
    opacity: 0.00001,
    left: -10000000
  },

  label: {
    display: 'block',
    margin: '0 0 0 1rem',
    fontSize: '1.4rem',
    color: TSS_DARK_BLUE()
  },

  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  }
});

export default enhance(Checkbox);